import React from 'react';
import { formatDistanceToNow } from 'date-fns';
import { Check, Trash2, Bell, MessageSquare, CheckCircle, AlertCircle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const NotificationDropdown = ({ notifications, onMarkAllRead, onClearAll, onClose }) => {
    const navigate = useNavigate();

    const handleItemClick = (notification) => {
        if (notification.link) {
            navigate(notification.link);
        }
        onClose();
    };

    const getIcon = (type) => {
        switch (type) {
            case 'task_assigned': return <CheckCircle size={16} className="text-green-500" />;
            case 'task_completed': return <CheckCircle size={16} className="text-blue-500" />;
            case 'chat_mention': return <MessageSquare size={16} className="text-purple-500" />;
            case 'system_alert': return <AlertCircle size={16} className="text-red-500" />;
            default: return <Bell size={16} className="text-slate-500" />;
        }
    };

    return (
        <div className="absolute right-0 top-full mt-2 w-80 bg-white rounded-xl shadow-xl border border-slate-100 z-50 animate-in fade-in zoom-in-95 duration-200 overflow-hidden">
            <div className="p-3 border-b border-slate-50 flex items-center justify-between bg-slate-50/50">
                <h3 className="font-bold text-slate-700 text-sm">Notifications</h3>
                <div className="flex items-center gap-2">
                    <button onClick={onMarkAllRead} className="text-[10px] text-blue-600 hover:text-blue-700 font-medium px-2 py-1 rounded hover:bg-blue-50 transition-colors">
                        Mark all read
                    </button>
                    <button onClick={onClearAll} className="text-slate-400 hover:text-red-500 transition-colors">
                        <Trash2 size={14} />
                    </button>
                </div>
            </div>

            <div className="max-h-80 overflow-y-auto">
                {notifications.length === 0 ? (
                    <div className="p-8 text-center text-slate-400 text-xs italic">
                        No notifications yet.
                    </div>
                ) : (
                    notifications.map(notification => (
                        <div
                            key={notification.id}
                            onClick={() => handleItemClick(notification)}
                            className={`p-3 border-b border-slate-50 hover:bg-slate-50 transition-colors cursor-pointer flex items-start gap-3 ${!notification.read ? 'bg-blue-50/30' : ''}`}
                        >
                            <div className="mt-0.5 shrink-0">
                                {getIcon(notification.type)}
                            </div>
                            <div className="flex-1 min-w-0">
                                <p className={`text-xs ${!notification.read ? 'font-semibold text-slate-800' : 'text-slate-600'}`}>
                                    {notification.title}
                                </p>
                                <p className="text-[11px] text-slate-500 mt-0.5 line-clamp-2">
                                    {notification.message}
                                </p>
                                <p className="text-[10px] text-slate-400 mt-1">
                                    {notification.timestamp ? formatDistanceToNow(new Date(notification.timestamp), { addSuffix: true }) : 'Just now'}
                                </p>
                            </div>
                            {!notification.read && (
                                <div className="w-2 h-2 rounded-full bg-blue-500 mt-1.5 shrink-0" />
                            )}
                        </div>
                    ))
                )}
            </div>
        </div>
    );
};

export default NotificationDropdown;
